






import { Vue, Component, Prop } from "vue-property-decorator";
import { IAffiliatePendingCommission } from "@/models/affiliate";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";

@Component({
  computed: {
    ...mapState({
      isAwaitingPayment(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isAwaitingPayment`
        ](this.commission);
      },
      isCancelled(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isCancelled`
        ](this.commission);
      },
      isOnHold(state, getters) {
        return getters[`data/${DataModules.AFFILIATES_COMMISSIONS}/isOnHold`](
          this.commission
        );
      },
      isPendingApproval(state, getters) {
        return getters[
          `data/${DataModules.AFFILIATES_COMMISSIONS}/isPendingApproval`
        ](this.commission);
      },
      isRejected(state, getters) {
        return getters[`data/${DataModules.AFFILIATES_COMMISSIONS}/isRejected`](
          this.commission
        );
      }
    })
  }
})
export default class CommissionAmountTag extends Vue {
  // Props

  @Prop({ required: true })
  public commission!: IAffiliatePendingCommission;

  // Computed

  public readonly isAwaitingPayment!: boolean;
  public readonly isCancelled!: boolean;
  public readonly isOnHold!: boolean;
  public readonly isPendingApproval!: boolean;
  public readonly isRejected!: boolean;

  public get type() {
    // Rejected
    if (this.isRejected) return "is-danger";
    // On hold
    if (this.isOnHold) return "is-grey";
    // Awaiting payment
    if (this.isAwaitingPayment) return "is-warning";
    // Pending approval
    if (this.isPendingApproval) return "is-warning";
    // Cancelled
    if (this.isCancelled) return "is-danger";
    // Approved
    return "is-success";
  }
}
